import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './core/App'
import './bootstrap.min.css'
import './index.css'
import registerServiceWorker from './registerServiceWorker'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import store from './core/store/configureStore'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { history } from './core/store/configureStore'

const MuiTheme = createMuiTheme(theme)
import theme from './theme'

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <MuiThemeProvider theme={MuiTheme}>
        <App />
      </MuiThemeProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root') as HTMLElement
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx